import { clsx } from 'clsx'
import { observer } from 'mobx-react-lite'

import { DrawerPanel } from 'shared/ui/drawer-panel/ui'
import { Paper } from 'shared/ui/paper'

import dialogBottomSheetStore from '../model/dialog-bottom-sheet-store'

import s from './styles.module.scss'

export const DialogBottomSheet = observer(() => {
  const onClose = () => {
    if (dialogBottomSheetStore.isClickable) {
      dialogBottomSheetStore.onHideDialog()
    }
  }

  if (dialogBottomSheetStore.isDialog) {
    return (
      <DrawerPanel
        rootProps={{
          open: dialogBottomSheetStore.isShow,
          onOpenChange: (open) =>
            !open && dialogBottomSheetStore.onHideDialog(),
        }}
        overlayProps={{
          className: s.wrapper,
        }}
        contentProps={{
          style: {
            maxHeight: dialogBottomSheetStore?.maxHeight,
            padding: '10px 16px max(16px, env(safe-area-inset-bottom, 0px))',
            background:
              dialogBottomSheetStore?.backgroundColor ??
              'var(--background-grey)',
          },
        }}
      >
        {dialogBottomSheetStore.child}
      </DrawerPanel>
    )
  }

  return (
    <div>
      <div
        className={clsx(dialogBottomSheetStore?.isShow && s.wrapper)}
        onClick={onClose}
      />

      <div
        onClick={onClose}
        className={clsx(
          !dialogBottomSheetStore?.isDialog &&
            dialogBottomSheetStore?.isShow &&
            s.dialogPopUpWrapper,
        )}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className={clsx(
            s.dialogPopUpClosed,
            !dialogBottomSheetStore?.isDialog &&
              dialogBottomSheetStore?.isShow &&
              s.dialogPopUpContent,
          )}
        >
          <Paper
            radius={dialogBottomSheetStore.borderRadius}
            padding={dialogBottomSheetStore.padding || [14]}
            backgroundColor={dialogBottomSheetStore?.backgroundColor}
          >
            <div
              className={s.content}
              style={{
                maxHeight: dialogBottomSheetStore?.maxHeight,
              }}
            >
              {dialogBottomSheetStore?.child}
            </div>
          </Paper>
        </div>
      </div>
    </div>
  )
})
